// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29UUz","colBig":"styles_colBig__1Shrv","colSmall":"styles_colSmall__3XFbH","shopifyNameWrapper":"styles_shopifyNameWrapper__2TqAx"};